module.exports = __webpack_public_path__ + "static/img/bg_poster.13d93e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_poster.png
// module id = XiNo
// module chunks = 0